const PlatformDefaults = {
  youtube: {
    title: "",
    description: "",
    visibility: "private",
    publishAt: null,
    audience: {
      madeForKids: false,
      ageRestricted: false,
    },
    metadata: {
      tags: [],
      categoryId: null,
      defaultLanguage: null,
      audioLanguage: null,
    },
    thumbnail: {
      mode: "auto",
      fileId: null,
    },
    captions: {
      enabled: false,
      fileId: null,
    },
    distribution: {
      allowEmbedding: true,
      notifySubscribers: true,
      license: "youtube",
      shortsRemixingAllowed: true,
    },
    comments: {
      enabled: true,
      mode: "allow_all",
    },
    recording: {
      location: null,
      date: null,
    },
  },

  meta: {
    surface: "reel",
    caption: "",
    hashtags: [],
    publishState: "draft",
    cover: {
      mode: "frame",
      fileId: null,
    },
    distribution: {
      shareToFeed: true,
      crosspost: false,
    },
    collaboration: {
      collaboratorIds: [],
    },
    brandedContent: {
      enabled: false,
      brandPartnerIds: [],
    },
    audience: {
      ageRestricted: false,
    },
    engagement: {
      commentsEnabled: true,
    },
    visibility: {
      value: "public",
    },
    locationId: null,
  },

  tiktok: {
    hashtags: [],
    publishState: "draft",
    cover: {
      fileId: null,
    },
    privacy: {
      visibility: "public",
    },
    engagement: {
      commentsEnabled: true,
    },
    reuse: {
      allowDuet: true,
      allowStitch: true,
      allowReuse: true,
    },
    brandedContent: {
      enabled: false,
    },
    audience: {
      ageRestricted: false,
    },
    locationId: null,
  },

  linkedin: {
    postText: "",
    visibility: "anyone",
    publishState: "publish_now",
    video: {
      thumbnailMode: "auto",
      thumbnailFileId: null,
    },
    captions: {
      mode: "auto",
      fileId: null,
    },
    engagement: {
      commentsEnabled: true,
    },
  },

  x: {
    text: "",
    hashtags: [],
    publishState: "publish_now",
    visibility: {
      value: "public",
    },
    engagement: {
      replySettings: "everyone",
    },
    sensitiveContent: {
      flagged: false,
    },
    monetization: {
      brandedContent: false,
    },
  },
};

export default PlatformDefaults;
